export default __webpack_public_path__ + "static/media/1.19ccd6b6.png";